import React, { ChangeEvent, useState } from 'react'

import { Text } from 'components/atoms/text'

import { StyledTextAreaContainer } from './index.styled'

type Props = {
  value: string
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void
  subTitle?: string
  className?: string
  textareaProps?: React.HTMLProps<HTMLTextAreaElement>
}

const TextArea = ({
  value,
  onChange,
  subTitle,
  className,
  textareaProps,
}: Props) => {
  const [focused, setFocused] = useState<boolean>(false)

  return (
    <StyledTextAreaContainer className={className} data-focused={focused}>
      <Text type="bodytext-3" className="subtitle">
        {subTitle}
      </Text>
      <textarea
        onBlur={() => setFocused(false)}
        onFocus={() => setFocused(true)}
        value={value}
        onChange={(e) => (onChange ? onChange(e) : undefined)}
        className="styled-scrollbar"
        {...textareaProps}
      />
    </StyledTextAreaContainer>
  )
}

export { TextArea }
